/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EventKind } from './eventKind';

export type TenantPublicSettingsEventKinds = { [key: string]: EventKind };
